module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAl0lEQVQokY3RMQ4BURSF4c9katMo0BE6hUKhtA0dkcwKVPbACiQaiUVoLECsQSNsgqheMpl4Y27335w/Nye3kef5GS28/Z4MMzwgRQejSBi2GAchwaciDFfcA6R/wnAqQlJDgAU2VRdGaBf4iTW6MWGKQWnXRD8m7Eu8xAWrOqXhiAP1Ss8xDJDUkCboBUjxwk38gRl2Ab4k3BQ4NHC4VQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/tc.png
// module id = 6oU3
// module chunks = 1